/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiEffectivenessConditionGroupPayloadFromJSON, ApiEffectivenessConditionGroupPayloadToJSON, } from './ApiEffectivenessConditionGroupPayload';
export function ApiEffectivenessRulePayloadFromJSON(json) {
    return ApiEffectivenessRulePayloadFromJSONTyped(json, false);
}
export function ApiEffectivenessRulePayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conditionGroups': !exists(json, 'conditionGroups') ? undefined : (json['conditionGroups'].map(ApiEffectivenessConditionGroupPayloadFromJSON)),
        'locations': !exists(json, 'locations') ? undefined : json['locations'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
export function ApiEffectivenessRulePayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conditionGroups': value.conditionGroups === undefined ? undefined : (value.conditionGroups.map(ApiEffectivenessConditionGroupPayloadToJSON)),
        'locations': value.locations,
        'name': value.name,
    };
}
